import {HOGARREDUCER} from '../types';

const INITIAL_STATE = null;

const hogarReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case HOGARREDUCER :
            return  action.payload;
        default: return state
    }
};

export default hogarReducer;